import React from 'react';

export default function ValidationReportModal({ report }) {
  if (!report) return null;
  return (
    <div style={{ display: 'grid', gap: '1rem', color: 'var(--text-primary)', maxWidth: '900px' }}>
      {/* Resumo */}
      <div className="glass" style={{ padding: '1rem', borderRadius: '16px', background: 'rgba(255,255,255,0.03)' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '0.75rem' }}>
          <div>Linha(s) antes: <strong>{report.rows_before}</strong></div>
          <div>Linha(s) depois: <strong>{report.rows_after}</strong></div>
          <div>Removidas sem contato: <strong>{report.removed_without_contacts}</strong></div>
          <div>Duplicadas removidas: <strong>{report.removed_duplicates}</strong></div>
        </div>
      </div>

      {/* Ajustes */}
      <div className="glass" style={{ padding: '1rem', borderRadius: '16px', background: 'rgba(255,255,255,0.03)' }}>
        <h4 style={{ color: 'var(--accent)', marginBottom: '0.75rem' }}>Ajustes executados</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '0.6rem' }}>
          <div>Telefones normalizados: <strong>{report.ajustes?.telefones_normalizados || 0}</strong></div>
          <div>Telefones inválidos removidos: <strong>{report.ajustes?.telefones_invalidos_removidos || 0}</strong></div>
          <div>WhatsApps normalizados: <strong>{report.ajustes?.whatsapps_normalizados || 0}</strong></div>
          <div>WhatsApps inválidos removidos: <strong>{report.ajustes?.whatsapps_invalidos_removidos || 0}</strong></div>
          <div>E-mails normalizados: <strong>{report.ajustes?.emails_normalizados || 0}</strong></div>
          <div>E-mails inválidos removidos: <strong>{report.ajustes?.emails_invalidos_removidos || 0}</strong></div>
        </div>
      </div>

      {/* Classificação */}
      <div className="glass" style={{ padding: '1rem', borderRadius: '16px', background: 'rgba(255,255,255,0.03)' }}>
        <h4 style={{ color: 'var(--accent-hot)', marginBottom: '0.75rem' }}>Classificação por contato</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '0.6rem' }}>
          <div>Email + WhatsApp: <strong>{report.classificacao?.['email+whatsapp'] || 0}</strong></div>
          <div>Apenas email: <strong>{report.classificacao?.email || 0}</strong></div>
          <div>Apenas WhatsApp: <strong>{report.classificacao?.whatsapp || 0}</strong></div>
          <div>Apenas telefone: <strong>{report.classificacao?.telefone || 0}</strong></div>
          <div>Sem contato: <strong>{report.classificacao?.sem_contato || 0}</strong></div>
        </div>
      </div>

      {/* Segmentos */}
      <div className="glass" style={{ padding: '1rem', borderRadius: '16px', background: 'rgba(255,255,255,0.03)' }}>
        <h4 style={{ color: 'var(--accent-strong)', marginBottom: '0.75rem' }}>Segmentos mais presentes</h4>
        <div style={{ display: 'grid', gap: '0.5rem' }}>
          {(report.segmentos || []).length === 0 ? (
            <div style={{ color: 'var(--text-secondary)' }}>Nenhum segmento identificado.</div>
          ) : (
            report.segmentos.map((item, i) => (
              <div key={`${item.segmento}-${i}`} style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                <span>{item.segmento}</span>
                <strong>{item.total}</strong>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Amostras */}
      <div className="glass" style={{ padding: '1rem', borderRadius: '16px', background: 'rgba(255,255,255,0.03)' }}>
        <h4 style={{ color: 'var(--accent)', marginBottom: '0.75rem' }}>Amostras de ajuste</h4>
        <div style={{ display: 'grid', gap: '0.75rem' }}>
          {(report.amostras || []).length === 0 ? (
            <div style={{ color: 'var(--text-secondary)' }}>Nenhuma linha precisou de ajuste visível.</div>
          ) : (
            report.amostras.map((item, i) => (
              <div
                key={`${item.Nome || 'linha'}-${i}`}
                style={{ padding: '0.75rem', borderRadius: '12px', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}
              >
                <div style={{ fontWeight: 700 }}>{item.Nome || 'Sem nome'}</div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '0.25rem' }}>
                  Segmento: {item.Categoria || 'sem-categoria'} • Classificação: {item.ClassificacaoContato || 'n/a'}
                </div>
                <div style={{ fontSize: '0.8rem', marginTop: '0.4rem' }}>
                  Campos ajustados: {(item.CamposAjustados || []).join(', ')}
                </div>
                <div style={{ fontSize: '0.8rem', marginTop: '0.4rem', color: 'var(--text-secondary)' }}>
                  Tel: {item.Telefone || '-'} • WhatsApp: {item.WhatsApp || '-'} • Email: {item.Emails || '-'}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

    </div>
  );
}
